import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiUrl, brands } from "../../config/config";

const RelatedProduct = ({ categoryId, categoryName }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const formattedName = categoryName
    ? categoryName.replace(/-/g, " ")
    : "Products";

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      
      try {
        // Only fetch by category ID
        const url = `${apiUrl}/api/${brands}/products/category/${categoryId}`;
        const res = await fetch(url);
        const data = await res.json();

        let productsList = [];

        if (Array.isArray(data)) {
          productsList = data;
        } else if (data.data && Array.isArray(data.data)) {
          productsList = data.data;
        }

        setProducts(productsList);
      } catch (err) {
        console.error("Product fetch error:", err);
        setProducts([]);
      }

      setLoading(false);
    };

    fetchProducts();
  }, [categoryId]);

  // -----------------------------
  // LOADING STATE
  // -----------------------------
  if (loading) {
    return <p className="text-center py-20">Loading products...</p>;
  }

  if (products.length === 0) {
    return (
      <p className="text-center py-20 text-gray-500">
        No products found in this category.
      </p>
    );
  }

  // -----------------------------
  // UI
  // -----------------------------
  return (
    <div className="w-full py-16 px-4">
      <h2 className="text-center text-3xl md:text-4xl font-bold tracking-wide">
        Related Product
      </h2>

      <div className="w-full flex justify-center mt-4 mb-10">
        <div className="w-1/3 border-t border-gray-400"></div>
      </div>

      {/* PRODUCT GRID */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        {products.map((item) => (
          <Link
            key={item.id}
            to={`/product/${item.category?.category_name?.replace(/\s+/g, "-") || "category"}/${item.category_id}/${item.name?.replace(/\s+/g, "-")}/${item.id}`}
            className="bg-white rounded-2xl shadow-sm hover:shadow-md transition p-6 cursor-pointer block"
          >
            {/* IMAGE */}
            <div className="rounded-2xl bg-[#F2ECFF] h-auto flex justify-center items-center">
              <img
                src={`${apiUrl}/storage/${item.image}`}
                alt={item.name}
                className="h-auto w-auto rounded-lg"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/placeholder-image.jpg"; // Add a placeholder
                }}
              />
            </div>

            {/* TITLE */}
            <h3 className="text-center text-lg md:text-xl font-semibold mt-5">
              {item.name}
            </h3>

            {/* PRICE */}
            <p className="text-center text-[#37404a] font-semibold text-md mt-2">
  As low as ${item.discountedPrice}
</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedProduct;